import React, { useState, useEffect } from "react";
import "../../components/DashboardSeller/UpdateStatusModal.css";
import { FaCheck } from "react-icons/fa";
import { getQuotationTrackingLogs, updateSellerOrderStatus } from "../../API/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UpdateStatusModal = ({ isOpen, onClose, quotation_id, onStatusUpdated }) => {
	const [status, setStatus] = useState("Confirmed");
	const [latestStatus, setLatestStatus] = useState("Confirmed");
	const [isUpdating, setIsUpdating] = useState(false);
	const [error, setError] = useState(null);

	const statuses = [
		"Confirmed",
		"Manufacturing",
		"Inspection",
		"Dispatched",
		"Delivered"
	];

	useEffect(() => {
		const fetchTrackingLogs = async () => {
			try {
				const res = await getQuotationTrackingLogs(quotation_id);
				if (res?.data?.length) {
					const latest = res.data[0].tracking_status;
					setLatestStatus(latest);
					setStatus(latest);
				}
			} catch (err) {
				console.error("Failed to fetch tracking logs:", err);
			}
		};

		if (quotation_id) {
			fetchTrackingLogs();
		}
	}, [quotation_id]);


	const handleUpdateStatus = async () => {
		if (!quotation_id) {
			setError("No order selected");
			toast.error("No quotation ID provided!");
			return;
		}

		setIsUpdating(true);
		setError(null);

		try {
			await updateSellerOrderStatus(quotation_id, { status });
			toast.success("Status updated successfully!");
			onClose();
			if (onStatusUpdated) {
				onStatusUpdated();
			}
		} catch (err) {
			const errMsg = err.message || "Failed to update status";
			setError(errMsg);
			toast.error(errMsg);
		} finally {
			setIsUpdating(false);
		}
	};

	return (
		<>
			<ToastContainer position="top-right" autoClose={5000} />
			{isOpen && (
				<div className="status-modal-overlay">
					<div className="status-modal-container">
						<h2 className="status-modal-title font-poppins">Update Status</h2>
						{error && <div className="status-error-message">{error}</div>}

						<div className="status-status-buttons">
							{statuses.map((item, index) => {
								const currentIndex = statuses.indexOf(latestStatus);
								const isCompleted = index < currentIndex;
								const isCurrent = item === status;
								const isDisabled = index < currentIndex;

								return (
									<button
										key={index}
										onClick={() => setStatus(item)}
										className={`status-status-button font-poppins ${isCurrent
											? "status-active"
											: isDisabled
												? "status-completed"
												: "status-disabled"
											}`}
										disabled={isDisabled}
									>
										{(isCompleted || isCurrent) && (
											<span
												className={`status-check-circle ${isCurrent ? "status-current-circle" : ""
													}`}
											>
												<FaCheck className="status-check-icon" />
											</span>
										)}
										{item}
									</button>
								);
							})}
						</div>

						<div className="status-modal-actions">
							<button
								className="status-update-button font-poppins"
								onClick={handleUpdateStatus}
								disabled={isUpdating}
							>
								{isUpdating ? "UPDATING..." : "UPDATE"}
							</button>
							<button
								onClick={onClose}
								className="status-cancel-button font-poppins"
								disabled={isUpdating}
							>
								CANCEL
							</button>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default UpdateStatusModal;
